const GQ = {
  ibanLength: 27,
};
export { GQ };
